import { Outlet } from 'react-router-dom';
import { TenantProvider } from '../app/TenantContext.js';
import { MainNavigation } from '../components/navigation/MainNavigation.js';
import { Footer } from '../components/layout/Footer.js';

export function TenantRouteLayout(): JSX.Element {
  return <TenantProvider><div className="tenant-route-layout"><MainNavigation /><main className="platform-main"><Outlet /></main><Footer /></div></TenantProvider>;
}
